export default __webpack_public_path__ + "static/media/83.d949ac47.png";